import angular from 'angular';

export default function($log, $stateParams, ApiClass, Swal) {
  'ngInject';
  const vm = this;

  vm.$onInit = activate;
  vm.selected = 0;

  vm.selectAllReminder = () => {
    for (let i = 0; i < vm.usersInvites.length; i++) {
      vm.usersInvites[i].sendReminder = angular.copy(vm.sendRemindedSelectAll.selected);
    }
    vm.updateSelected();
  };

  vm.sendRemindedSelectAll = {
    selected: false
  };

  vm.updateSelected = () => (vm.selected = vm.usersInvites.filter(user => user.sendReminder).length);

  vm.sendReminders = () => {
    vm.sendingInvites = true;
    const id = $stateParams.eventid;
    const courseInvitations = vm.usersInvites.filter(({ sendReminder }) => sendReminder).map(({ uuid }) => uuid);

    return ApiClass.eventsIdTypePatch(
      { id, type: 'invites' },
      { courseInvitations, resend: true },
      { queryParams: { manage: true } }
    )
      .then(res => {
        $log.debug('Sent Reminders', res);
        vm.usersInvites.forEach(user => {
          if (!user.sendReminder) return;
          user.sendReminder = false;
          user.updated_at = new Date().toISOString();
        });
      })
      .then(() => {
        Swal.toast('The invitations have been re-sent');
        vm.sendingInvites = false;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    if (!vm.event) return;
    vm.isPastEvent = new Date(vm.event.delivery_date) < new Date();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/invitees/controller.js